import React from 'react';
import Icon from '../../../components/AppIcon';

const CustomerApprovalTable = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-primary" />
      </div>
    );
  }

  if (!data?.length) {
    return (
      <div className="flex flex-col items-center justify-center py-10 text-muted-foreground">
        <Icon name="Users" size={36} className="mb-2 opacity-30" />
        <p className="text-sm">No customer data available</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-muted/30">
            <th className="px-4 py-3 text-left font-semibold text-muted-foreground">Customer</th>
            <th className="px-4 py-3 text-right font-semibold text-muted-foreground">Total</th>
            <th className="px-4 py-3 text-right font-semibold text-muted-foreground">Approved</th>
            <th className="px-4 py-3 text-right font-semibold text-muted-foreground">Rejected</th>
            <th className="px-4 py-3 text-right font-semibold text-muted-foreground">Rate</th>
            <th className="px-4 py-3 text-right font-semibold text-muted-foreground">Avg Response</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((row) => (
            <tr key={row?.customer} className="border-b border-border hover:bg-muted/20 transition-colors">
              <td className="px-4 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
                    {row?.customer?.charAt(0)?.toUpperCase()}
                  </div>
                  <span className="font-medium text-foreground">{row?.customer}</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right text-muted-foreground">{row?.total}</td>
              <td className="px-4 py-3 text-right">
                <span className="text-green-600 font-medium">{row?.approved}</span>
              </td>
              <td className="px-4 py-3 text-right">
                <span className="text-red-600 font-medium">{row?.rejected}</span>
              </td>
              <td className="px-4 py-3 text-right">
                <div className="flex items-center justify-end gap-2">
                  <div className="w-16 bg-gray-200 rounded-full h-1.5">
                    <div
                      className="bg-green-500 h-1.5 rounded-full"
                      style={{ width: `${row?.rate}%` }}
                    />
                  </div>
                  <span className="text-xs font-semibold text-foreground w-8 text-right">{row?.rate}%</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right text-muted-foreground">{row?.avgResponse}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerApprovalTable;
